import { IAction } from 'core/interface/action';
import { IIndustry } from 'core/interface/companies';

export const SAVE_LOCATION = 'save-industries';

const defaultState = {
  industry: null
};

export const SaveIndustries = (value: IIndustry[]) => ({
  type: SAVE_LOCATION,
  payload: value
});

const industriesReducer = (
  state = defaultState,
  action: IAction<IIndustry[]>
) => {
  switch (action.type) {
    case SAVE_LOCATION:
      return {
        ...state,
        industry: action.payload
      };
    default:
      return state;
  }
};

export default industriesReducer;
